import { LineOfficialAccountService } from '../../providers'

const LineOfficialAccountModule = {
  namespaced: true,
  state: {
    updateLineOfficialAccountResult: {}
  },
  mutations: {
    SET_UPDATE_LINE_OFFICIAL_ACCOUNT_RESULT (state, data) {
      state.updateLineOfficialAccountResult = data
    }
  },
  actions: {
    async fetchLineOfficialAccountByBasicId (context, basicId) {
      return LineOfficialAccountService.fetchLineOfficialAccountByBasicId(basicId)
    },
    async updateLineOfficialAccount ({ commit }, params) {
      const result = await LineOfficialAccountService.updateLineOfficialAccount(params)
      commit('SET_UPDATE_LINE_OFFICIAL_ACCOUNT_RESULT', result)
      return result
    }
  }
}

export default LineOfficialAccountModule
